import { memo, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import ChooseGender from "@/components/ChooseGender";
import { Routes as AppRoutes } from "@/constants/routes";
import FriendsFlow from "@/FriendsFlow";
import usePreloadGoalImgs from "@/hooks/usePreloadGoalImgs";
import OfferFlow from "@/OfferFlow";
import { Genders } from "@/types/gender";
import { useCurrency } from "@/utils/GeolocationProvider";
import { lazyWithPreload } from "@/utils/lazyPreload";

const MaleFlow = lazyWithPreload(() => import("@/male/MaleFlow"));
const FemaleFlow = lazyWithPreload(() => import("@/female/FemaleFlow"));

MaleFlow.preload();
FemaleFlow.preload();

const BothFlow = () => {
    usePreloadGoalImgs();
    const { loadCurrencies } = useCurrency();

    useEffect(() => {
        loadCurrencies();
    }, [loadCurrencies]);

    return (
        <Routes>
            <Route path="*" element={<ChooseGender />} />
            <Route path={Genders.Male} element={<MaleFlow />} />
            <Route path={Genders.Female} element={<FemaleFlow />} />
            <Route path={`${AppRoutes.Friends}/*`} element={<FriendsFlow />} />
            <Route path={`${AppRoutes.Offer}/*`} element={<OfferFlow />} />
        </Routes>
    );
};

export default memo(BothFlow);
